// extracted by mini-css-extract-plugin
export default {"rulesSlide":"RulesSlide_rulesSlide__VUNiF","contentSlide":"RulesSlide_contentSlide__5NMlD"};